<!--
    @name: 首页工程工队
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-08-26 11:23:14
-->
<template>
  <div>
    <MainTitle title="工程工队" path="/teamList" :titleImg="require('@/assets/onef.png')"
      :tabOption="tabOption"
      @tabSelect="tabSelect"/>
    <div class="content">
      <div v-if="loading">
        <el-row :gutter="20">
          <el-col :span="12" :key="index" v-for="(item,index) in 6">
            <el-skeleton style="width: 100%">
              <template slot="template">
                <div style="margin: 10px 5px;padding: 10px;border: 1px solid #e4e7ed">
                  <div style="display: flex">
                    <div>
                      <el-skeleton-item variant="image" style="width: 60px; height: 60px;" />
                    </div>
                    <div style="padding-left: 10px">
                      <el-skeleton-item variant="text" style="width: 200px" />
                      <div>
                        <el-skeleton-item variant="text" style="width: 150px" />
                      </div>
                    </div>
                  </div>
                  <el-skeleton-item variant="text" style="width: 300px" />
                  <el-skeleton-item variant="text" style="width: 300px" />
                  <el-skeleton-item variant="text" style="width: 300px" />
                  <hr style="border: dashed 1px #eee;margin: 5px 0">
                  <el-skeleton-item variant="text" style="width: 300px" />
                </div>
              </template>
            </el-skeleton>
          </el-col>
        </el-row>
      </div>
      <div >
        <el-row :gutter="20" v-if="type==0||type==1">
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <cardTeam :item="item" :type="1"></cardTeam>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="type==2">
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <cardEngineeringCompany :item="item" :type="2"></cardEngineeringCompany>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="type==3">
          <el-col :span="12" v-for="(item,index) in list" :key="index">
            <cardWorkerList :item="item" :type="3"></cardWorkerList>
          </el-col>
        </el-row>
        <paging :sq="this.param.page>1" :gd="list.length<this.param.total" @pageupdata="pageupdata"></paging>
      </div>
      <!-- 无数据 -->
      <BaseEmptyData v-if="!list.length && !loading"></BaseEmptyData>
    </div>
  </div>
</template>

<script>
import {apiResignAll} from "@/api/apiResignAll"
import cookie from "@/storage/cookies"
import {apiWorker} from "@/api/apiWorker"
import {apiEngineeringCompany} from "@/api/apiEngineeringCompany"
import {apiLaborServiceCompany} from "@/api/apiLaborServiceCompany"

export default {
  name: "team",
  components: {
    MainTitle: () => import("@/views/Home/AllComponents/MainTitle"), // 头部组件
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"), // 无数据组件
    paging: () => import("./paging"), // 分页组件
    cardTeam: () => import("@/components/card/cardTeam"), // 工程工队card组件
    cardEngineeringCompany: () => import("@/components/card/cardEngineeringCompany"), // 工程公司card组件
    cardWorkerList: () => import("@/components/card/cardWorkerList"), // 专业工人card组件

  },
  data(){
    return {
      tabOption:[
        { title: "施工队", type: "0" },
        { title: "班组工队", type: "1" },
        { title: "工程公司", type: "2" },
        // { title: "专业工人", type: "3" }
        // { title: '劳务公司', type: '4' }
      ],
      type:'0',
      list:[],
      param:{
        page: 1,
        limit: 6,
        total:0,
        sortType:'1'
      },
      code:{},
      loading:true
    }
  },
  created() {
    this.tabSelect({type:'0'});
  },
  methods:{
    pageupdata(v){
      if(v)this.param.page=v
      else this.param.page++;
      this.getlist();
    },
    tabSelect(v){
      this.type=v.type;
      //参数封装
      let code={}
      let cookieArea = cookie.cookieRead("area");
      let area = cookieArea ? JSON.parse(cookieArea) : null
      if(area)code.provinceNo = area.id
      switch (v.type) {
        case "0":
          code.teamType=v.type;
          this.func=apiResignAll.teamInfoSearchList;//获取施工队，班组列表数据
          break
        case "1":
          code.teamType=v.type;
          this.func=apiResignAll.teamInfoSearchList;//获取施工队，班组列表数据
          break
        case "2":
          this.func=apiEngineeringCompany.list;//获取工程公司列表筛选数据
          break
        case "3":
          this.func= apiWorker.teamInfoSearchList;//获取建设工人列表筛选数据
          break
        case "4":
          this.func= apiLaborServiceCompany.getserviceCompany;//获取劳务公司列表筛选数据
          break
      }
      //参数重置
      this.code=code;
      this.param.page=1;
      this.getlist();
    },
    //获取数据列表
    async getlist(){
      if(this.param.page==1){
        this.list=[];
        this.param.total=0;
      }
      this.loading=true;
      let param={...this.param,...this.code}
      if(this.type==3){
        param.pageNum=param.page
        param.pageSize=param.limit
      }
      //处理工程公司
      if(this.type==2){
        if(process.env.VUE_APP_NAME ==="production"){
        param.profile='pro'
      }else if(process.env.VUE_APP_NAME==='pre'){
        param.profile='pro'
      }else if(process.env.VUE_APP_NAME==='development'){
        param.profile='dev'
      }
      }
      let res=await this.func(param)
      if (res.data && res.data.code === 200){
        this.loading=false;
        if(this.param.page==1)this.list=res.data.data.records;
        else this.list=this.list.concat(res.data.data.records)
        this.param.total=res.data.data.total
      }
    },
    getList(){
      this.pageupdata(1)
      this.$emit('changeHash','box1')
    }
  },
  provide(){
    return {
      cardListCom:this
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    width: 1200px;
    min-height: 200px;
    padding: 0 20px;
    background: #fff;
    box-sizing: border-box;
    margin: auto;
    /deep/.empty-data{
      padding: 0 0 20px;
    }
  }
</style>
